import { Elastic, Power0, TweenMax } from "gsap";
import { AddMouseDownListener, LogGroup, Rect, Size } from "../.././MyHelpers";
import { service } from "../../services";
import { FreegamePickCallback } from "../FreegameBonus/FreegamePickElement";
import { CanvasSprite } from "../Sprite/CanvasSprite";
import { StateChange, StateMachine } from "../StateMachine";
import { PickBonusCashReward, PickBonusJackpotReward, PickBonusPickElementParams, PickBonusReward } from "./PickBonusParams";
import { PickSprite } from "./PickSprite";

export enum PickBonusElemState {
	Idle,
	WaitToPick,
	NotPicked,           Picked,
	WaitDisplayRemainig, WaitDisplayAward,
	DisplayRemaining,    DisplayAward,
						 
}

export type PickBonusCallback = (index: number) => void;
export type PickBonusAwardDisplayedCallback = (index: number) => void;
export type PickBonusRemainingDisplayedCallback = (index: number) => void;

export class PickBonusElement
{
	protected index:number = 0;

	protected sprite: CanvasSprite = null;
	protected displaySize: Size = null;
	protected pickRect: Rect = null;
	protected awardRect: Rect = null;

	protected view: HTMLElement = null;
	protected pickElem: HTMLElement = null;
	//CHANGE TO CANVAS
	//public awardElem: HTMLElement = null;
	//CREATE CANVAS AWARD
	//public awardElemCanvas: HTMLCanvasElement = null;
	//CHANGE NORMAL TEXT
	public awardElem: HTMLElement = null;
	
	protected ctx:CanvasRenderingContext2D = null;
  
	protected anim_waitpick: TweenMax = null;
	protected anim_bringfront: TweenMax = null;
	protected anim_pushback: TweenMax = null;
	protected myscale: number = 1;

	protected stateMachine: StateMachine<PickBonusElemState> = null;
	protected pickCallback: PickBonusCallback = null;

	protected reward: PickBonusReward = null;
	protected pickSprite:PickSprite = null;
	protected logGroup: LogGroup = null;
	public isPicked:boolean = false;

	// remaining reveal must be requested
	private remainining_requestReveal: boolean = false;
	protected award_animEnded: boolean = false;

	protected spriteDuration:number = 0;
	//LOAD Font
	protected fontFamily: string;
	protected fontsize:string="40px";

	//constructor(logGroup: LogGroup, index: number, displayRect: PixelRect, pickRect: PixelRect, awardRect: PixelRect, sprite: CanvasSprite,  pickSprite:PickSprite, moneyFormatter: MoneyFormatter)
	constructor(params: PickBonusPickElementParams)
	{
		
		//Load FOnt
		this.fontFamily=params.fontFamily;
		this.index = params.index;
		this.logGroup = params.logGroup.Add(["PickBonusElement", "" + this.index]);
		this.stateMachine = new StateMachine<PickBonusElemState>(PickBonusElemState.Idle, this.logGroup, (state: PickBonusElemState) => {return PickBonusElemState[state];});
		
		this.stateMachine.SetCallback(PickBonusElemState.WaitToPick, StateChange.Begin, () => this.OnWaitToPickBegin());

		this.stateMachine.SetCallback(PickBonusElemState.Picked, StateChange.Begin, () => this.OnPickedBegin());
		this.stateMachine.SetCallback(PickBonusElemState.WaitDisplayAward, StateChange.Begin, () => this.OnWaitDisplayAwardBegin());
		this.stateMachine.SetCallback(PickBonusElemState.DisplayAward, StateChange.Begin, () => this.OnDisplayAwardBegin());

		this.stateMachine.SetCallback(PickBonusElemState.NotPicked, StateChange.Begin, () => this.OnNotPickedBegin());
		this.stateMachine.SetCallback(PickBonusElemState.WaitDisplayRemainig, StateChange.Begin, () => this.OnWaitDisplayRemainingBegin());
		this.stateMachine.SetCallback(PickBonusElemState.DisplayRemaining, StateChange.Begin, () => this.OnDisplayRemainingBegin());
		
		this.displaySize = params.displaySize;
		this.pickRect = params.pickRect;
		this.awardRect = params.awardRect;
		this.pickSprite = params.pickSprite;
		this.sprite = params.sprite;
		//this.sprite.canvas.context.shadowBlur = 20;
		//this.sprite.canvas.context.shadowColor = "yellow";
		this.sprite.AddOnCompleteCallback(() => this.OnSpriteComplete());
		this.anim_bringfront = TweenMax.to(this, 0.1, {myscale: 1, ease: Power0.easeNone, paused: true, onComplete: () => this.stateMachine.ChangeState(PickBonusElemState.WaitDisplayAward)});
		this.anim_pushback = TweenMax.to(this, 1, {myscale: 1, ease: Power0.easeNone, paused: true, onComplete: () => this.stateMachine.ChangeState(PickBonusElemState.WaitDisplayRemainig)});
		this.WaitAnimPick();

		
		this.AwardElemePrepare();

		this.view = document.createElement("div");
		//this.view.style.position = "absolute";
		// this.view.style.left = this.displaySize.x + "px";
		// this.view.style.top = this.displaySize.y + "px";
		this.view.style.width = this.displaySize.Width + "px";
		this.view.style.height = this.displaySize.Height + "px";
		//this.view.style.boxSizing = "border-box";
		this.view.style.border = "10px solid rgb(228,203,76)";
		this.view.style.borderRadius = "20px";
		this.view.style.backgroundColor = "rgba(0,0,0,0.5)";
		this.view.style.pointerEvents = "none";
		this.view.style.boxShadow = "inset 0 0 0px 1px black, inset 0 0 0px 2px black ,0px 0px 0px 1px black, 0px 0px 0px 2px black";

		this.pickElem = document.createElement("div");
		this.pickElem.classList.add("pick");
		this.pickElem.style.position = "absolute";
		this.pickElem.style.left = (this.pickRect.x/* - this.displayRect.x*/) + "px";
		this.pickElem.style.top = (this.pickRect.y/* - this.displayRect.y*/) + "px";
		this.pickElem.style.width = this.pickRect.width + "px";
		this.pickElem.style.height = this.pickRect.height + "px";
		this.pickElem.style.pointerEvents = "auto";

		AddMouseDownListener(this.pickElem, () => this.Picked());

		this.spriteDuration = this.sprite.GetDuration();
		
		this.view.appendChild(this.sprite.View());
		this.view.appendChild(this.pickElem);
		//this.view.appendChild(this.awardElem);
		this.view.appendChild(this.awardElem);
		
	}


	

	
	public WaitAnimPick()
	{
		this.anim_waitpick = TweenMax.fromTo(this, 1, {myscale: 0.8}, {myscale: 0.85, yoyo: true, repeat: -1, ease: Power0.easeNone, paused: true});
	}

	public AwardElemePrepare()
	{
		//CHANGE TO CANVAS
	 	this.awardElem = document.createElement("div");
		this.awardElem.classList.add("award");
		this.awardElem.style.position = "absolute";
		this.awardElem.style.left = this.pickRect.x+ "px";
		this.awardElem.style.top = this.pickRect.y+ 3+ "px";
		this.awardElem.style.width = this.awardRect.width+  "px";
		this.awardElem.style.height = this.awardRect.height+ "px";
		this.awardElem.style.visibility = "hidden";
		this.awardElem.style.fontSize = this.fontsize;
		this.awardElem.style.fontFamily = this.fontFamily;
		this.awardElem.style.color = "white";
		this.awardElem.style.textShadow = "0px 0px 0px #000000, 0px 0px 1px #000000, 0px 0px 2px #000000, 0px 0px 3px #000000, 0px 0px 4px #000000, 0px 0px 5px #000000, 0px 0px 6px #000000, 0px 0px 6px #000000";
		this.awardElem.style.display = "flex";
		this.awardElem.style.alignItems = "center";
		this.awardElem.style.justifyContent = "center"; 
		this.awardElem.style.textAlign="center";
	}
	public Recover(award: PickBonusReward):void
	{
		this.reward = award;
		this.isPicked = true;
		this.stateMachine.ChangeState(PickBonusElemState.DisplayAward, {quiet: false});

		this.DisplaySprite();
		this.sprite.Start(false);

		setTimeout(() => {
			//debugger;
			//CHANGE TO CANVAS
			//this.awardElem.style.visibility = "visible";
			this.awardElem.style.visibility="visible";

		}, 350);

		this.ZoomSelected();
		

	}

	public PickRect(): Rect
	{
		return this.pickRect;
	}

	public DisplaySize(): Size
	{
		return this.displaySize;
	}


	public AddPickCallback(callback: FreegamePickCallback): void {
		this.pickCallback = callback;
	}

	public BringToFront() {
		this.stateMachine.ChangeState(PickBonusElemState.Picked);
	}

	public PushToBack() {
		this.stateMachine.ChangeState(PickBonusElemState.NotPicked);
	}

	public ZoomSelected():void
	{
		//TweenLite.to(this.awardElem,1,{scale:1.5});
		//CHANGE TO CANVAS
		//TweenMax.fromTo(this.awardElem, 0.5, {scale: 1}, {scale: 1.5, ease:Elastic.easeOut});
		TweenMax.fromTo(this.awardElem, 0.5, {scale: 1}, {scale: 1.3, ease:Elastic.easeOut});
		
		this.sprite.canvas.context.shadowOffsetX = 0;
		this.sprite.canvas.context.shadowOffsetY = 0;
		this.sprite.canvas.context.shadowBlur = 50;
		this.sprite.canvas.context.shadowColor = "rgba(255, 0, 255, 1)";
	}

	private ResetBlur():void
	{
		this.sprite.canvas.context.shadowBlur = 0;
	}



	private Picked() {
		if(this.isPicked)
		{
			// Log.Debug(this.logGroup, "Already picked");
		}
		else
		{
			// Log.Debug(this.logGroup, "Picked");
			//this.isPicked = true;
			if (this.pickCallback != null) {
				this.pickCallback(this.index);
			}
		}
		
	}
	public Reset(): void {

		// Log.Debug(this.logGroup, "Resetting");

		this.reward = null;
		//CHANGE TO CANVAS
		/* this.awardElem.innerHTML = "";
		this.awardElem.style.visibility = "hidden";
 		*/
		this.awardElem.innerHTML = "";
		this.awardElem.style.visibility = "hidden";
		//this.awardElem.classList.remove("award-remaining");
		
		this.ResetBlur();
		
		this.sprite.ChangeSprite(this.pickSprite.spriteCoin);

		this.sprite.Reset();
		this.myscale = 1;
		this.sprite.Scale(this.myscale);
		this.sprite.Update(true);

		//this.award = null;
		this.remainining_requestReveal = false;
		this.isPicked = false;
	}

	public Start(): void {
		this.Reset();
		this.stateMachine.ChangeState(PickBonusElemState.WaitToPick);
	}

	public Update(): void {
		//debugger;
		this.sprite.Scale(this.myscale);
		this.sprite.Update(true);
	}

	public GetCurretnElement(): PickBonusReward
	{
		let element:PickBonusReward = this.reward;
		return element;
	}

	private DisplaySprite():void
	{
		if(this.reward.PickType == 1)
		{
			this.sprite.ChangeSprite(this.pickSprite.spriteCoin);

			setTimeout(()=>
			{
				//CHANGE TO CANVAS
				//this.awardElem.innerHTML = this.moneyFormatter.FormatCredit((this.reward as PickBonusCashReward).Reward.InCents);
				let awardtext:string = service.moneyFormatter.FormatCreditCurrentDenom((this.reward as PickBonusCashReward).Reward.InCents)
			/* 	this.ctx.textAlign="center";
				this.ctx.strokeText(awardtext, (this.awardRect.width)/2,(this.awardRect.height)/2);
   
				this.ctx.fillText(awardtext, (this.awardRect.width)/2, (this.awardRect.height)/2);
			 */	this.awardElem.innerHTML=awardtext;
				//CAHGNE TP CANVAS
				//TweenMax.fromTo(this.awardElemCanvas, 0.5, {scale: 0.2, opacity: 0}, {scale: 1, opacity: 1, ease: Power0.easeNone});
				TweenMax.fromTo(this.awardElem, 0.5, {scale: 0.2, opacity: 0}, {scale: 1, opacity: 1, ease: Power0.easeNone});
		
			}, 0);
			// Log.Debug(this.logGroup,"Playing sprite", this.pickSprite.spriteCoin.Name());
			
		}

		else if(this.reward.PickType == 2)
		{
			let jackpotReward = this.reward as PickBonusJackpotReward;

			if(jackpotReward.JackpotName == "jp1")
			{
				this.sprite.ChangeSprite(this.pickSprite.spriteJp1);

				// Log.Debug(this.logGroup,"Playing sprite", this.pickSprite.spriteJp1.Name());
			}
			else if(jackpotReward.JackpotName == "jp2")
			{
				this.sprite.ChangeSprite(this.pickSprite.spriteJp2);

				// Log.Debug(this.logGroup,"Playing sprite", this.pickSprite.spriteJp2.Name());
			}
			else if(jackpotReward.JackpotName == "jp3")
			{
				this.sprite.ChangeSprite(this.pickSprite.spriteJp3);
				// Log.Debug(this.logGroup,"Playing sprite", this.pickSprite.spriteJp3.Name());
			}
			else if(jackpotReward.JackpotName == "jp4")
			{
				this.sprite.ChangeSprite(this.pickSprite.spriteJp4);
				// Log.Debug(this.logGroup,"Playing sprite", this.pickSprite.spriteJp4.Name());
			}
			
			if (this.awardElem.innerHTML.length > 0) debugger;
		}
		else{
			// Log.Debug(this.logGroup, "Unknown award");
		}
		this.sprite.Reset();
	}

	public SetIndex(index:number)
	{
		this.index = index;
	}

	// award
	public SetAward(award: PickBonusReward): void {
		this.reward = award;
		this.DisplaySprite();
		this.TryDisplayAward();
	}

	private TryDisplayAward(): void {
		
		if (this.stateMachine.State() == PickBonusElemState.WaitDisplayAward && this.reward != null) {
			this.stateMachine.ChangeState(PickBonusElemState.DisplayAward);
		}
	}

	// remaining
	public SetRemaining(award: PickBonusReward): void {
		//debugger;
		this.reward = award;
		this.DisplaySprite();
		
		this.TryDisplayRemaininig();
	}

	// display remaining, if all conditions are met
	private TryDisplayRemaininig(): void {
		if (this.stateMachine.State() == PickBonusElemState.WaitDisplayRemainig && 
			this.remainining_requestReveal &&
			this.reward != null
			) 
		{
			this.stateMachine.ChangeState(PickBonusElemState.DisplayRemaining);
		}
	}

	public CurrentState(): PickBonusElemState {
		return this.stateMachine.State();
	}


	// callback - award has been displayed
	private displayedCallbacks: PickBonusAwardDisplayedCallback[] = [];
	public  AddPickBonusAwardDisplayedCallback(callback: PickBonusAwardDisplayedCallback): void {
		this.displayedCallbacks.push(callback);
	}

	private OnAwardDisplayed() {
		// Log.Debug(this.logGroup, "Award has been displayed");

		for (let i = 0; i < this.displayedCallbacks.length; i++) {
			this.displayedCallbacks[i](this.index);
		}
	}

	// Command to reveal remaining
	public RevealRemaining() {
		//debugger;
		//if (this.stateMachine.State() == PickBonusElemState.WaitDisplayRemainig) {
			//this.awardElem.classList.add("award-remaining");
			this.remainining_requestReveal = true;
			this.TryDisplayRemaininig();
		//}
		//else {
		/*	debugger;
			Log.Error(this.logGroup, "Wrong state to reveal remaining, current state: " + PickBonusElemState[this.stateMachine.State()] + ", required state: " + PickBonusElemState[PickBonusElemState.WaitDisplayRemainig]);
		}*/
	}

	// callback - remainig has been displayed
	private remainingCallbacks: PickBonusRemainingDisplayedCallback[] = [];
	public AddPickBonusRemainingDisplayedCallback(callback: PickBonusRemainingDisplayedCallback): void {
		this.remainingCallbacks.push(callback);
	}

	private OnRemainingDisplayed(): void {
		// Log.Debug(this.logGroup, "Remaining has been displayed");

		for (let i = 0; i < this.remainingCallbacks.length; i++) {
			this.remainingCallbacks[i](this.index);
		}
	}


	// reveal sprite has finished, the award/remaining is now visible
	private OnSpriteComplete(): void {
		if (this.stateMachine.State() == PickBonusElemState.DisplayAward) {
			// finished displaying award
			this.OnAwardDisplayed();
		}
		else {
			// finished displaying remaining
			this.OnRemainingDisplayed();
		}
	}





	// states

	// waiting for pick
	protected OnWaitToPickBegin(): void {
		// Log.Debug(this.logGroup, "Starting wait pick anim");
		this.anim_waitpick.restart();
	}

	// either picked...
	protected OnPickedBegin(): void {
		// bring to front
		// Log.Debug(this.logGroup, "Bringing to front");

		this.anim_waitpick.kill();
		this.anim_bringfront.restart();
	}

	// picked, try to display award
	protected OnPickedEnd(): void {
		// Log.Debug(this.logGroup, "Bringing to front finished");

		this.award_animEnded = true;
		this.TryDisplayAward();
	}

	// ... or not picked
	protected OnNotPickedBegin(): void {
		// push to back
		// Log.Debug(this.logGroup, "Sending to back");

		this.anim_waitpick.kill();
		this.anim_pushback.restart();
	}

	private OnNotPickedEnd(): void {
		// Log.Debug(this.logGroup, "Sending to back finished");

		this.award_animEnded = true;
	}

	// waiting for award to be displayed
	protected OnWaitDisplayAwardBegin(): void {
		this.TryDisplayAward();
	}

	// displaying award
	private OnDisplayAwardBegin(): void {
		// Log.Debug(this.logGroup, "Displaying award");
		this.sprite.Start(false);

		setTimeout(() => {
			//debugger;
			//CHANGE TO CANVAS
			//this.awardElem.style.visibility = "visible";
			this.awardElem.style.visibility = "visible";
			
			//this.anim_awardZoomIn.restart();

			if (this.OnDisplayAwardCallback != null)
				this.OnDisplayAwardCallback();

		}, 0);
	}

	public OnDisplayAwardCallback: (() => void) = null;
	public OnDisplayRemainingCallback: (() => void) = null;


	// waiting for remaining to be displayed 
	private OnWaitDisplayRemainingBegin(): void {
		this.TryDisplayRemaininig();
		//this.sprite.Start(false);
		//this.awardElem.style.visibility = "visible";
	}

	// displaying remaining
	protected OnDisplayRemainingBegin(): void {
		// Log.Debug(this.logGroup, "Displaying remaining");
		this.sprite.Start(false);
		//this.awardElem.style.visibility = "visible";
		setTimeout(() => {
			//CHANGE TO CANVAS
			//this.awardElem.style.visibility = "visible";
			this.awardElem.style.visibility = "visible";
			
			//this.anim_awardZoomIn.restart();

			if (this.OnDisplayRemainingCallback != null)
				this.OnDisplayRemainingCallback();
		}, 0);
	}



	public View():HTMLElement
	{
		return this.view;
	}
}